<script>
import { Bar } from "vue-chartjs";
import firebase from "firebase";
import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
export default {
  extends: Bar,
  name: "OrdersChart",
  data() {
    return {
      orders: null,
      items: null,
      collection: firebase.firestore().collection("orders")
    };
  },
  async mounted() {
    var startOfWeek = this.moment().startOf("week");
    var endOfWeek = this.moment().endOf("week");
    var days = [];
    var day = startOfWeek;

    while (day <= endOfWeek) {
      days.push(day.toDate());
      day = day.clone().add(1, "d");
    }

    const last7days = startOfWeek.toDate();
    last7days.setHours(0, 0, 0);
    await this.collection
      .where("createDate", ">=", last7days)
      .get()
      .then(res => {
        let items = [];
        res.forEach(r => {
          const m = r.data();
          const date = this.moment
            .unix(m.createDate.seconds)
            .format("YYYY-MM-DD");
          items.push({
            date: date,
            count: 1
          });
        });
        this.items = items;
      });

    var groups = this._.groupBy(this.items, "date");
    groups = this._.map(groups, g => {
      return {
        date: g[0].date,
        count: g.length
      };
    });
    this.orders = [];
    days.forEach(d => {
      var f = this._.find(
        groups,
        g => g.date == this.moment(d).format("YYYY-MM-DD")
      );
      if (f) this.orders.push(f.count);
      else this.orders.push(0);
    });

    this.renderChart(
      {
        labels: [
          this.t(["Sun", "ທິດ"]),
          this.t(["Mon", "ຈັນ"]),
          this.t(["Tue", "ຄານ"]),
          this.t(["Wed", "ພຸດ"]),
          this.t(["Thu", "ພະຫັດ"]),
          this.t(["Fri", "ສຸກ"]),
          this.t(["Sat", "ເສົາ"])
        ],
        datasets: [
          {
            label: this.t(["Number of orders", "ຈຳນວນອໍເດີ"]),
            backgroundColor: "#20a8d8",
            // data: [50, 70, 82, 39, 30, 40, 39, 0, 100]
            data: this.orders
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: 1
                // suggestedMax: 50
              }
            }
          ]
        },
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: "index",
          position: "nearest",
          callbacks: {
            labelColor: function(tooltipItem, chart) {
              return {
                backgroundColor:
                  chart.data.datasets[tooltipItem.datasetIndex].backgroundColor
              };
            }
          }
        }
      }
    );
  }
};
</script>